exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".year-grid[data-v-193beb75]{display:grid;grid-template-columns:1fr 1fr 1fr 1fr;column-gap:16px;row-gap:16px}.month-item.is-selected[data-v-193beb75]{color:var(--black);background-color:var(--cyan-light-1)}@media(min-width:600px)and (max-width:800px){.calendar-section>div[data-v-193beb75]{margin-left:100px;margin-right:100px}.calendar-section[data-v-193beb75]{justify-content:center}}@media(max-width:600px){.no-trip-container[data-v-193beb75]{border:none}.calendar-month[data-v-193beb75]{max-width:320px;margin-left:auto;margin-right:auto}}", ""]);

// exports
